export default "__VITE_ASSET__cgXzyiFM__"